export function startOfDayUTC(timestamp: number, offsetDays: number = 0): number {
  const date: Date = new Date(timestamp);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + offsetDays);
}

export function endOfDayUTC(timestamp: number): number {
  const date: Date = new Date(timestamp);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999);
}
